import comp from "./TagPost";
export default comp;
